import { useState, useEffect, useCallback } from 'react';
import RecordTypeService from '../service';

function useRecordTypes(entity) {
  const [recordTypes, setRecordTypes] = useState([]);
  const [isLoadingRecordTypes, setIsLoadingRecordTypes] = useState(false);

  const getRecordTypes = useCallback(
    async (params = {}) => {
      setIsLoadingRecordTypes(true);
      params.entity = entity;

      try {
        const response = await RecordTypeService.list(params);
        const recordTypeData = response.data.recordTypes;
        setRecordTypes(recordTypeData);
      } catch (error) {
        console.error('Erro ao buscar os tipos de registro:', error);
        setRecordTypes([]);
      } finally {
        setIsLoadingRecordTypes(false);
      }
    },
    [entity]
  );

  useEffect(() => {
    getRecordTypes();
  }, [getRecordTypes]);

  return { recordTypes, isLoadingRecordTypes };
}

export { useRecordTypes };
